import { useEffect, useState } from 'react';

// No top navigation, popups or downloads: the page can run, not take over the screen.
const SANDBOX =
  'allow-scripts allow-same-origin allow-forms allow-presentation';

/** A web page in a sandboxed iframe, optionally zoomed and reloaded on an interval. */
export const WebPageItem = ({ item }) => {
  const { url, refreshSeconds = 0, zoom = 100 } = item.settings || {};
  const [reloads, setReloads] = useState(0);

  useEffect(() => {
    if (!(refreshSeconds > 0)) return;
    const timer = setInterval(
      () => setReloads((n) => n + 1),
      refreshSeconds * 1000,
    );
    return () => clearInterval(timer);
  }, [refreshSeconds]);

  const scale = zoom > 0 ? zoom / 100 : 1;
  return (
    <div className="absolute inset-0 overflow-hidden bg-white">
      <iframe
        key={reloads}
        src={url}
        title="Web page"
        sandbox={SANDBOX}
        referrerPolicy="no-referrer"
        allow="autoplay; fullscreen"
        style={{
          border: 0,
          width: `${100 / scale}%`,
          height: `${100 / scale}%`,
          transform: `scale(${scale})`,
          transformOrigin: '0 0',
        }}
      />
    </div>
  );
};
